<template>

    <div class="home">
        <!--<div class="homecontainer">
            <iframe src="https://www.veeamliveapj.com/page/1619804/homelobby" frameborder="0"></iframe>
        </div>-->

        <img src="../assets/VeeamLiveWebsite.png" alt="">
    </div>

</template>





<script>

    export default {
        name: 'Home',
    }

</script>



<style scoped>

    .home {
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;

        display: flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        background-color: #004550;
    }

    img {
        width: 100%;

        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
    }

    /*
    .homecontainer {
        position: absolute; top: 0; left: 0; right: 0; bottom: 0;
    }

    iframe {
        display: block; width: 100%; height: 100%; border: none;
    }
    */



</style>

